/**
 * Route Restriction Configurations
 *
 * This file contains all route restriction configurations used by the RouteGuard component.
 * Add new restrictions here as needed for different features.
 */

export const routeRestrictions = [
    // Re-KYC Restriction - highest priority
    {
        flag: 'rekycRequired',
        allowedPath: '/re-kyc',
        priority: 120,
        description: 'Restricts all routes to Re-KYC page when Re-KYC is required'
    },
    // Video KYC Restriction
    // When KYC is incomplete or rejected, user can only access the KYC management page
    {
        flag: 'kycRestricted',
        allowedPath: '/video-kyc/customer-management',
        priority: 100, // High priority - KYC is critical
        description: 'Restricts all routes when Video KYC is incomplete or rejected'
    },
    {
        flag: 'kycPending',
        allowedPath: '/merchant-home',
        priority: 110,
        description: 'Restricts routes to home when Video KYC is pending',
        dialog: {
            title: 'Verification Pending',
            message:
                'Your Video KYC is currently pending verification. You can access the home page, but other features are restricted until verification is complete.',
            agreeText: 'Check Status',
            onAgreeAction: 'CHECK_KYC_STATUS'
        }
    }

    // Example: Profile Completion Restriction
    // Uncomment and modify as needed for future features
    // {
    //     flag: 'profileIncomplete',
    //     allowedPath: '/complete-profile',
    //     priority: 50,
    //     description: 'Restricts routes when user profile is incomplete'
    // },

    // Example: Agreement Acceptance Restriction
    // {
    //     flag: 'agreementPending',
    //     allowedPath: '/accept-agreement',
    //     priority: 75,
    //     description: 'Restricts routes when user has not accepted terms'
    // }
];
